<template>
	<div>
		<div
			class=" pointer itemUsed"
			:class="[labelSetColor + ' lighten-3']"
			@click.capture="editLodging(lodging)"
		>
			<div :class="itemActive" style="height: 40px">
				<template v-if="toggleIconsLabel || toggleIconsAssistance || toggleIconsOT">
					<status-icon
						:lodging="lodging"
						:dayTable="date.numberDay"
						:toggleIconsAssistance="toggleIconsAssistance"
					/>
					<div
						v-if="
							compareDates({
								text: true,
								start: lodging.start,
								end: lodging.end,
								dayTable: date.numberDay,
							})
						"
						class="maxContent"
					>
						<div
							class="caption textIntoDIV"
							v-if="
								!lodging.userNotifications.length &&
									toggleIconsLabel &&
									!toggleIconsAssistance
							"
						>
							<v-icon dark x-small>
								mdi-bell-cancel
							</v-icon>
						</div>
						<div class="caption textIntoDIV" v-if="toggleIconsOT">
							<v-icon :color="lodging.workOrder.length ? 'success' : 'error'" small>
								{{
									lodging.workOrder.length
										? 'mdi-check-circle'
										: 'mdi-alert-circle'
								}}
							</v-icon>
						</div>
						<div
							class="caption textIntoDIV"
							v-if="
								!lodging.histories.length &&
									!toggleIconsLabel &&
									toggleIconsAssistance
							"
						>
							<v-icon dark x-small>
								mdi-alert-circle
							</v-icon>
						</div>
					</div>
				</template>
				<template v-else>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<div
								v-on="on"
								v-bind="attrs"
								v-if="
									compareDates({
										text: true,
										start: lodging.start,
										end: lodging.end,
										dayTable: date.numberDay,
									})
								"
								class="maxContent"
							>
								<div class="caption textIntoDIV" v-if="!periodSelected">
									<v-btn
										fab
										x-small
										elevation="0"
										:color="
											lodging.color != '#616161' && lodging.color
												? lodging.color
												: labelColor
										"
										dark
										style="width: 15px; height: 15px; font-size: 10px "
										class="mr-1"
									>
										{{ lodging.room.substring(0, 2) }}
									</v-btn>
								</div>
							</div>
						</template>
						<span>{{ lodging.room.substring(0, 15) }}</span>
					</v-tooltip>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	props: {
		periods: {
			type: Array,
			default: () => [],
		},
		toggleIconsAssistance: {
			type: Boolean,
			default: false,
		},
		toggleIconsOT: {
			type: Boolean,
			default: false,
		},
		lodging: {
			type: Object,
			default: null,
		},
		date: {
			type: Object,
			default: null,
		},
		compareDates: {
			type: Function,
			required: true,
		},
		editLodging: {
			type: Function,
			required: true,
		},
		toggleIconsLabel: {
			type: Boolean,
			required: true,
		},
		periodSelected: {
			type: String,
			default: '',
		},
	},
	components: {
		StatusIcon: () => import('@/components/lodgings/StatusIcon'),
	},
	computed: {
		labelSetColor() {
			if (this.lodging && this.lodgingSelect) {
				if (this.lodging._id == this.lodgingSelect._id) return ' itemUsedSelected ';
			}
			return this.lodging.color != '#616161' && this.lodging.color
				? this.lodging.color
				: this.labelColor;
		},
		labelSetColorInitial() {
			if (
				this.compareDates({
					text: true,
					start: this.lodging.start,
					end: this.lodging.end,
					dayTable: this.date.numberDay,
				})
			)
				return this.lodging.color != '#616161' && this.lodging.color
					? this.lodging.color
					: this.labelColor;
			else return 'transparent';
		},
		labelPeriods() {
			if (this.periods.length)
				return this.periods.findIndex(el => el.period == this.lodging.room) + 1;
			return '1';
		},
		labelColor() {
			const item = this.periods.find(el => el.period == this.lodging.room);
			if (item) return item.color;
			else return null;
		},
		itemActive() {
			let itemWithProblems = false;
			let itemUsedSelected = false;
			if (this.lodgingWithProblems)
				itemWithProblems = this.lodging._id == this.lodgingWithProblems._id;
			itemUsedSelected = this.lodging == this.lodgingSelect;
			return {
				itemWithProblems,
				itemUsedSelected,
				itemValidated:
					this.userValidationLodging(this.lodging.userNotifications) == 'green' &&
					!itemWithProblems &&
					!itemUsedSelected,
				itemNoValidated:
					this.userValidationLodging(this.lodging.userNotifications) == 'red' &&
					!itemWithProblems &&
					!itemUsedSelected,
				itemPeding:
					this.userValidationLodging(this.lodging.userNotifications) == 'orange' &&
					!itemWithProblems &&
					!itemUsedSelected,
			};
		},
		...mapGetters({
			lodgingWithProblems: 'Lodging/lodgingWithProblems',
			lodgingSelect: 'Lodging/lodgingSelect',
		}),
	},
	methods: {
		userValidationLodging(allNotifications) {
			if (allNotifications.length) {
				switch (allNotifications[0].state) {
					// success
					case 1:
						return 'green';
					// denied
					case 2:
						return 'red';
					// pending
					case 3:
						return 'orange';
					default:
						break;
				}
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.itemUsed {
	width: calc(100% + 0px);
	height: 40px;
	background-color: #4ea6f099;

	float: right;
	font-size: 11px;
	transition: all ease-in-out 0.5s;
}

.textIntoDIV {
	text-align: left;
	padding-left: 5px;
	padding-top: 2px;
	position: static;
	z-index: 2;
	// line-height: 13px;
}
.itemUsedSelected {
	background-color: #6a31ffbd !important;
	border-left: none;
}
.itemWithProblems {
	background-color: red !important;
}
.itemValidated {
	background-color: #61c16861 !important;
}
.itemNoValidated {
	background-color: #f30e0e61 !important;
}
.itemPeding {
	background-color: #fdc600 !important;
}
.maxContent {
	width: max-content;
}
</style>
